'use client'

import { PropsWithChildren, createContext, use, useContext } from 'react'

type BlendVisionContextType = {
  sdkLicenseKey: string
}

type BlendVisionProviderProps = PropsWithChildren<{
  sdkLicenseKeyPromise: Promise<string>
}>

const BlendVisionContext = createContext<BlendVisionContextType | null>(null)

export function BlendVisionProvider({ children, sdkLicenseKeyPromise }: BlendVisionProviderProps) {
  const sdkLicenseKey = use(sdkLicenseKeyPromise)

  return (
    <BlendVisionContext.Provider value={{ sdkLicenseKey }}>{children}</BlendVisionContext.Provider>
  )
}

export const useBlendVisionContext = () => {
  const value = useContext(BlendVisionContext)

  if (value == null) {
    throw new Error('useBlendVisionContext cannot be used outside of BlendVisionProvider')
  }

  return value
}
